import React from 'react';

const FormField = ({ children, type = 'large' }) => (
  <div
    className={`email-signup-form-field email-signup-form-field--${type}`}
    data-test="form-field-container"
  >
    {children}
  </div>
);

export default FormField;
